export default {
  strict: true,
  namespaced: true,
  state: {
    id: '',
    active: false,
    services: [],
    backgroundSubmitted: 0,
    backgroundPassed: 0,
    isTestAcct: false,
    maxDailyRsvpIsCustom: 0,
    maxDailyRsvp: 0,
    created: '',
    ptrsDriverAgreeUTC: '',
    basicInfo: {
      firstName: '',
      lastName: '',
      deviceOS: '',
      deviceModel: '',
      language: '',
      email: '',
      countryCode: '',
      phoneNumber: '',
      mobile: '',
      birthday: '',
      img: '',
      homeSectorId: null
    },
    vehicleInfo: {
      manufacturer: '',
      model: '',
      year: '',
      type: '',
      licensePlate: '',
      capacity: '',
      door: '',
      identificationNumber: '',
      wheelchair: '',
      serviceDog: '',
      img: ''
    },
    accountType: {
      tcpPermit: '',
      type: ''
    },
    businessInfo: {
      name: '',
      type: '',
      address: '',
      address2: '',
      city: '',
      country: '',
      state: '',
      zip: '',
      w9fileImg: ''
    },
    documentation: {
      insuranceCompany: '',
      insurancePolicy: '',
      insuranceExp: '',
      insuranceImg: '',
      cityLicense: '',
      cityLicenseExp: '',
      cityLicenseImg: '',
      tcpPermit: '',
      tcpPermitExp: '',
      tcpPermitImg: '',
      airportPermit: '',
      airportPermitExp: '',
      airportPermitImg: '',
      driversLicense: '',
      driversLicenseExp: '',
      driversLicenseImg: '',
      vehicleInspection: '',
      vehicleInspectionExp: '',
      vehicleInspectionImg: '',
      drivingRecordExp: '',
      drivingRecordImg: ''
    },
    eligibility: {
      convicted: '',
      conviction: '',
      ownVehicle: '',
      modifiedVehicle: '',
      driversLicense: ''
    },
    signature: '',
    homeAdress: '',
    formHasError: false,
    formLoading: false,
    formSave: {
      isDone: false,
      message: ''
    },
    upload: {
      error: false,
      show: false,
      ref: ''
    },
    serviceSave: {
      loading: false,
      modal: false,
      success: false,
      message: ''
    },
    isDoorToDoorEnabled: false,
    quickRes: {
      enable: false,
      loading: false,
      modal: false
    },
    driverId: '',
    driverIdLoading: false
  },
  mutations: {
    resetuserInfo (state) {
      state.active = false
      state.services = []
      state.backgroundSubmitted = 0
      state.backgroundPassed = 0
      state.isTestAcct = false
      state.maxDailyRsvpIsCustom = 0
      state.maxDailyRsvp = 0
      state.created = ''
      state.ptrsDriverAgreeUTC = ''
      state.basicInfo = {
        firstName: '',
        lastName: '',
        deviceOS: '',
        deviceModal: '',
        language: '',
        email: '',
        countryCode: '',
        phoneNumber: '',
        mobile: '',
        birthday: '',
        img: '',
        homeSectorId: null
      }
      state.vehicleInfo = {
        manufacturer: '',
        model: '',
        year: '',
        type: '',
        licensePlate: '',
        capacity: '',
        door: '',
        identificationNumber: '',
        wheelchair: '',
        serviceDog: '',
        img: ''
      }
      state.accountType = {
        tcpPermit: '',
        type: ''
      }
      state.businessInfo = {
        name: '',
        type: '',
        address: '',
        address2: '',
        city: '',
        country: '',
        state: '',
        zip: '',
        w9fileImg: ''
      }
      state.documentation = {
        insuranceCompany: '',
        insurancePolicy: '',
        insuranceExp: '',
        insuranceImg: '',
        cityLicense: '',
        cityLicenseExp: '',
        cityLicenseImg: '',
        tcpPermit: '',
        tcpPermitExp: '',
        tcpPermitImg: '',
        airportPermit: '',
        airportPermitExp: '',
        airportPermitImg: '',
        driversLicense: '',
        driversLicenseExp: '',
        driversLicenseImg: '',
        vehicleInspection: '',
        vehicleInspectionExp: '',
        vehicleInspectionImg: '',
        drivingRecordExp: '',
        drivingRecordImg: ''
      }
      state.eligibility = {
        convicted: '',
        conviction: '',
        ownVehicle: '',
        modifiedVehicle: '',
        driversLicense: ''
      }
      state.signature = ''
      state.homeAdress = ''
      state.formHasError = false
      state.formLoading = false
      state.formSave = {
        isDone: false,
        message: ''
      }
    },
    setUserInfo (state, value) {
      state.id = value.id
      state.active = value.active
      state.services = value.services
      state.backgroundSubmitted = value.backgroundSubmitted
      state.backgroundPassed = value.backgroundPassed
      state.isTestAcct = value.isTestAcct
      state.maxDailyRsvpIsCustom = value.maxDailyRsvpIsCustom
      state.maxDailyRsvp = value.maxDailyRsvp
      state.created = value.created
      state.ptrsDriverAgreeUTC = value.ptrsDriverAgreeUTC
      state.basicInfo = value.basicInfo
      state.vehicleInfo = value.vehicleInfo
      state.accountType = value.accountType
      state.businessInfo = value.businessInfo
      state.documentation = value.documentation
      state.eligibility = value.eligibility
      state.signature = value.signature
      state.homeAdress = value.homeAdress
    },
    setHomeSectorId (state, value) { state.basicInfo.homeSectorId = value },
    setActive (state, value) { state.active = value },
    setAccountType (state, value) { state.accountType.type = value },
    setFormHasError (state, value) { state.formHasError = value },
    setFormLoading (state, value) { state.formLoading = value },
    setFormSavingDone (state, value) { state.formSave.isDone = value },
    setFormSaveMessage (state, value) { state.formSave.message = value },
    showCropper (state, value) {
      state.upload.show = value.show
      state.upload.ref = value.ref
    },
    showUploadError (state, value) { state.upload.error = value },
    setServiceSaveLoading (state, value) { state.serviceSave.loading = value },
    serviceSaveModal (state, value) { state.serviceSave.modal = value },
    serviceSaveSuccess (state, data) {
      state.serviceSave.success = data.success
      state.serviceSave.message = data.message
    },
    setIsDoorToDoorEnabled (state, value) { state.isDoorToDoorEnabled = value },
    setQuickResData (state, data) {
      for (let field in data) {
        state.quickRes[field] = data[field]
      }
    },
    setDriverId (state, value) { state.driverId = value },
    setDriverIdLoading (state, value) { state.driverIdLoading = value }
  },
  sharedMutations: []
}



// WEBPACK FOOTER //
// ./src/store/provider/user-info.js